import { useCallback } from 'react'

export const useYupValidationResolver = (validationSchema: any) =>
  useCallback(
    async data => {
      try {
        await validationSchema.validate(data, {
          abortEarly: false
        })

        return {
          values: data,
          errors: {}
        }
      } catch (errors: any) {
        return {
          values: {},
          errors: errors.inner.reduce(
            (allErrors: any, currentError: any) => ({
              ...allErrors,
              [currentError.path]: {
                type: currentError.type ?? 'validation',
                message: currentError.message
              }
            }),
            {}
          )
        }
      }
    },
    [validationSchema]
  )
